var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrapper",attrs:{"id":"our-services"}},[_c('p',{staticClass:"services-header"},[_vm._v("Our services")]),_c('div',{staticClass:"services-wrapper"},_vm._l((_vm.services),function(service,index){return _c('ServiceCard',{key:index,attrs:{"image-path":service.imagePath,"text":service.text,"sub-text":service.subText}})}),1)])
}
var staticRenderFns = []

export { render, staticRenderFns }